import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@kundeninfo/ui/tokens.css";
import spriteSvg from "@kundeninfo/ui/sprite.svg?raw";
import { applyTheme, readCachedTheme } from "@kundeninfo/ui";
import { App } from "./App.js";
import { OfflineHinweis } from "./pwa/OfflineHinweis.js";
import { registerSw } from "./pwa/registerSw.js";

const wurzel = document.getElementById("root");
if (wurzel === null) throw new Error("Wurzelelement #root fehlt in index.html.");

/**
 * Den zwischengespeicherten Stand so früh wie möglich anwenden — vor dem ersten
 * Zeichnen von React, nicht erst nach der Antwort auf GET /api/session (siehe
 * App.tsx, wo applyTheme danach mit dem verbindlichen Stand aus der Datenbank
 * überschreibt). Ohne diese Zeile lief ein Benutzer mit dunklem Schema beim Laden
 * kurz durch die helle Ladeseite, bevor der Umschlag passierte — genau die Lücke, die
 * readCachedTheme() eigentlich schließen sollte (Fixrunde 1, Befund 1). readCachedTheme()
 * validiert den Browserwert selbst (er kommt aus localStorage und könnte fehlen,
 * veraltet oder von Hand verändert sein) und fällt bei Unbrauchbarem auf SYSTEM/COMPACT
 * zurück — hier wird ihm deshalb blind vertraut.
 */
const zwischengespeichert = readCachedTheme();
applyTheme(zwischengespeichert.scheme, zwischengespeichert.density, zwischengespeichert.schrift);

/**
 * Icon aus @kundeninfo/ui zeichnet ausschließlich `<use href="#fa-…">` — ein reiner
 * Dokumentfragment-Verweis, der nur auflöst, wenn das Sprite mit den <symbol>-Definitionen
 * bereits im Dokument steht. @kundeninfo/ui liefert dafür jetzt einen eigenen Exportpfad
 * ("./sprite.svg"); "?raw" holt seinen Inhalt zur Bauzeit als Zeichenkette (Vite bündelt ihn
 * mit in den JS-Code, siehe vite/client.d.ts). Das Einhängen läuft deshalb synchron, bevor
 * React überhaupt zu zeichnen beginnt — anders als beim vorigen fetch()-Behelf gibt es kein
 * Rennen mehr zwischen Sprite und erstem Zeichnen.
 */
const spriteBehaelter = document.createElement("div");
spriteBehaelter.setAttribute("hidden", "");
spriteBehaelter.innerHTML = spriteSvg;
document.body.insertBefore(spriteBehaelter, document.body.firstChild);

createRoot(wurzel).render(
  <StrictMode>
    <OfflineHinweis />
    <App />
  </StrictMode>,
);

registerSw();
